import React, { useState } from "react";
import "./waitList.css";
import HomeHeader from "../home/new/components/homeHeader";
import NarrowInputField from "../components/input/new/narrowInputField";
import NarrowDropdown2 from "../components/input/new/narrowDropdown2";

const WaitList = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("client"); // default selection
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/addWaitlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, role }),
      });
      const data = await res.json();
      if (res.ok) {
        console.log("Success:", data);
        setMessage("Thanks for joining the waitlist!");
        setEmail("");
        setRole("client");
      } else {
        console.error("Submission error:", data.error);
        setMessage("There was an error. Please try again later.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setMessage("There was an error. Please try again later.");
    }
  };

  const userRoles = [
    { label: "Attorney", value: "attorney" },
    { label: "Client", value: "client" },
  ];

  return (
    <div>
      <div className="home-header-wrapper">
        <HomeHeader
          isTitle={false}
          title={""}
          headerColor="header-white"
          navItems={true}
        />
      </div>
      <div className="waitlist-section">
        <h1 className="waitlist-title">Democratizing Legal Help</h1>
        <p className="description">
          At quidpro, we bridge the gap between lawyers and clients.
        </p>
        <p className="waitlist-cta">
          Subscribe now for exclusive early access, insider updates, and a
          revolutionary approach to connecting with legal experts.
        </p>
        <form onSubmit={handleSubmit} className="waitlist-form">
          <div>
            <NarrowInputField
              title="Email Address"
              placeholder="E.g connect@quidpro.ai"
              isRequired={true}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              halfWidth={false}
            />

            <NarrowDropdown2
              title="Role"
              placeholder="Select your role"
              items={userRoles}
              isRequired={true}
              value={role}
              onChange={(e) => setRole(e)}
              multiple={false}
              halfWidth={true}
            />
          </div>
          <button style={{ backgroundColor: "#144A8C" }} type="submit">
            Join the Waitlist
          </button>
          {/* need to fix */}
        </form>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default WaitList;
